import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import useNcId from "hooks/useNcId";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { DayPickerSingleDateController, SingleDatePicker } from "react-dates";
import { useWindowSize } from "react-use";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ExperiencesDateSingleInput from "./HeroSearchForm/ExperiencesDateSingleInput";

const ModalSelectDate = ({
  defaultValue,
  onClose,
  onSelectDate,
  renderChildren,
  component,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [focusedInput, setFocusedInput] = useState(false);
  const [startDate, setStartDate] = useState(defaultValue);
  const [selectedDate, setSelectedDate] = useState(moment());
  // const [stateDate, setStateDate] = useState(defaultValue);
  // const [focusedInputSectionCheckDate, setFocusedInputSectionCheckDate] =
  //   useState<FocusedInputShape>("startDate");

  // useEffect(() => {
  //   setStateDate(defaultValue);
  // }, [defaultValue]);

  // FOR RESET ALL DATA WHEN CLICK CLEAR BUTTON
  //
  function closeModal() {
    setShowModal(false);
  }

  function openModal() {
    setShowModal(true);
  }

  const renderButtonOpenModal = () => {
    return renderChildren ? (
      renderChildren({ openModal })
    ) : (
      <button onClick={openModal}>Select Date</button>
    );
  };
  useEffect(() => {
    setStartDate(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    setFocusedInput(false);
  }, [focusedInput]);

  const handleDateFocusChange = (arg) => {
    setFocusedInput(arg.focused);
  };
  const startDateId = useNcId();

  const windowSize = useWindowSize();

  return (
    <>
      {renderButtonOpenModal()}
      <Transition appear show={showModal} as={Fragment}>
        <Dialog
          as="div"
          className="HeroSearchFormMobile__Dialog relative z-50"
          onClose={closeModal}
        >
          <div className="fixed inset-0 bg-neutral-100 dark:bg-neutral-900">
            <div className="flex h-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out transition-transform"
                enterFrom="opacity-0 translate-y-52"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in transition-transform"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-52"
              >
                <Dialog.Panel className="relative h-full overflow-hidden flex-1 flex flex-col justify-between ">
                  <>
                    <div className="absolute left-4 top-4">
                      <button
                        className="focus:outline-none focus:ring-0"
                        onClick={closeModal}
                      >
                        <XMarkIcon className="w-5 h-5 text-black dark:text-white" />
                      </button>
                    </div>

                    <div className="flex-1 pt-12 p-1 flex flex-col overflow-hidden">
                      <div className="absolute inset-0 flex mt-10 justify-center">
                        {component()}
                      </div>
                    </div>
                    <div className="px-4 py-3 bg-white dark:bg-neutral-900 border-t border-neutral-200 dark:border-neutral-700 flex justify-between">
                      <ButtonPrimary
                        sizeClass="px-6 py-3 !rounded-xl"
                        onClick={() => {
                          closeModal();
                        }}
                      >
                        Save
                      </ButtonPrimary>
                    </div>
                  </>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default ModalSelectDate;
